import React from "react";
import { HashLink as Link } from "react-router-hash-link";

const Forms = () => {
  //   const history = useHistory();

  return (
    <div className="container-fluid">
      <h2>Select the component you wish to modify.</h2>
      <nav>
        <ul className="list-group">
          <li className="list-group-item">
            <Link to={`#profile`}>Profile</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#education`}>Education</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#courses`}>Courses</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#publications`}>Publications</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#researchInterests`}>Research Interests</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#researchFunding`}>Research Funding</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#editorialAppointments`}>Editorial Appointments</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#currentStudents`}>Current Students</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#formerStudents`}>Former Students</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#award`}>Awards</Link>
          </li>
          <li className="list-group-item">
            <Link to={`#academicPositions`}>Academic Positions</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Forms;
